import React, { useEffect, useState } from "react";
import sliderData from "./sliderData";
import API_BASE_URL from "../../config/api";

const foodSliderFallback = [
  {
    id: 101,
    tagline: "Fresh & Organic",
    title: "Farm Fresh Food Delivered",
    subtitle: "Quality you can taste",
    cta: "Order Now",
    image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=1200",
  },
  {
    id: 102,
    tagline: "3 Amigos",
    title: "Delicious Meals & Snacks",
    subtitle: "Freshly prepared for you",
    cta: "Explore Menu",
    image: "https://images.unsplash.com/photo-1504674900247-0877df9cc836?w=1200",
  },
  {
    id: 103,
    tagline: "Daily Specials",
    title: "Healthy & Tasty Options",
    subtitle: "Discover our food collection",
    cta: "Shop Now",
    image: "https://images.unsplash.com/photo-1606787366850-de6330128bfc?w=1200",
  },
];

const HomeSlider = ({ foodMode = false }) => {
  const [current, setCurrent] = useState(0);
  const [isInteracting, setIsInteracting] = useState(false);
  const [slides, setSlides] = useState(foodMode ? foodSliderFallback : sliderData);

  useEffect(() => {
    let mounted = true;
    const category = foodMode ? 'food' : 'non-food';
    const fallback = foodMode ? foodSliderFallback : sliderData;
    const fetchBanners = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/slider-banners/public?category=${category}`, { cache: 'no-store' });
        const data = await res.json().catch(() => ({}));
        if (!mounted) return;
        if (res.ok && Array.isArray(data.banners) && data.banners.length > 0) {
          const mapped = data.banners.map((b, idx) => ({
            id: b.id || idx + 1,
            tagline: foodMode ? "3 Amigos" : "TechBegin",
            title: "",
            subtitle: "",
            cta: "Shop Now",
            image: b.imageUrl,
          }));
          setSlides(mapped);
        } else {
          setSlides(fallback);
        }
      } catch (e) {
        if (mounted) setSlides(fallback);
      }
    };

    fetchBanners();
    setCurrent(0);
    return () => {
      mounted = false;
    };
  }, [foodMode]);

  useEffect(() => {
    if (isInteracting) return;
    if (slides.length <= 1) return;
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(timer);
  }, [isInteracting, slides.length]);

  useEffect(() => {
    if (current >= slides.length) setCurrent(0);
  }, [slides.length, current]);

  return (
    <div id="home-hero" className="container mx-auto px-4 mt-4">
      {/* Slider Card */}
      <div
        className="relative overflow-hidden rounded-2xl shadow-lg h-48 md:h-64"
        onPointerDown={() => setIsInteracting(true)}
        onPointerUp={() => setIsInteracting(false)}
        onPointerCancel={() => setIsInteracting(false)}
        style={{ touchAction: "pan-y" }}
      >
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              index === current ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={slide.image}
              alt={slide.title || 'Banner'}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Dots */}
      {slides.length > 1 && (
        <div className="flex justify-center mt-3 space-x-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrent(index)}
              className={`h-2 rounded-full transition-all duration-300 ${
                index === current
                  ? (foodMode ? "bg-green-500 w-6" : "bg-blue-600 w-6")
                  : "bg-gray-300 w-2"
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default HomeSlider;
